<template>
	<div id="about">
		<span class="fa fa-angle-down" v-if="page < pageCount" @click="page++"></span>
		<ul id="about-pager">
			<li :active="page==1"></li>
			<li :active="page==2"></li>
			<li :active="page==3"></li>
		</ul>
		<div page="1" :active="page == 1">
			<h1>
				专业的
				<span>IPO</span>咨询顾问
			</h1>
			<div>
				<div>
					<div></div>
				</div>
			</div>
		</div>
		<div page="2" :active="page == 2">
			<div content>
				<div>
					<h1></h1>
					<p>美信咨询是较早开展IPO咨询服务的企业之一，在IPO咨询领域处于较为领先的位置，拥有良好的口碑。 依托专业、高效、敬业的精英团队，强大的合作关系网络，美信咨询IPO项目团队在IPO及再融资细分市场调研、IPO及再融资募投可行性研究、IPO可行性分析和规划、IPO一体化咨询、IPO财务顾问等方面积累了丰富的专业经验。</p>
					<h2></h2>
				</div>
			</div>
			<div map></div>
			<div box>
				<div class="container">
					<div left>
						<div>
							<div class="rectbox rectbox1">
								<div class="rect rect1">
									<div>
										<span>
											<span>300</span>
											<span>+</span>
										</span>
										<p>数十个IPO项目案例</p>
									</div>
								</div>
								<div class="rect rect2">
									<div>
										<span>
											<span>32</span>
										</span>
										<p>业务遍及10+省市</p>
									</div>
								</div>
							</div>
							<div class="rectbox rectbox2">
								<div class="rect rect1">
									<div>
										<span>
											<span>12</span>
										</span>
										<p>12年IPO经验</p>
									</div>
								</div>
								<div class="rect rect2">
									<div>
										<span>
											<span>100</span>
											<span>+</span>
										</span>
										<p>合计融资数十亿</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div right>
						<div>
							<div class="rectbox rectbox1">
								<div class="rect rect1">
									<div>
										<span class="fa fa-bar-chart-o"></span>
										<p>产经大数据平台</p>
									</div>
								</div>
								<div class="rect rect2">
									<div>
										<span class="fa fa-balance-scale"></span>
										<p>跨地域跨业务领域的综合性投资银行服务</p>
									</div>
								</div>
							</div>
							<div class="rectbox rectbox2">
								<div class="rect rect1">
									<div>
										<span class="fa fa-line-chart"></span>
										<p>获得多项荣誉和行业资质</p>
									</div>
								</div>
								<div class="rect rect2">
									<div>
										<span class="fa fa-users"></span>
										<p>100+专业投资银行顾问</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div page="3" :active="page == 3">
			<div content>
				<div>
					<h1></h1>
					<p>我们始终将我们所内外所有的客户置于我们言行的核心。我们对于挑战市场以共同创造一个共享的未来充满热忱。这植根于我们宏大的愿景且因我们的行动力而自信。同一个团队，同一个机构。我们相信团结一致的力量将为我们的员工，客户以及公司自身带来良好结果。我们如同一个家庭般运作，跨文化协同合作并相互支持。</p>
					<h2></h2>
				</div>
			</div>
			<div box>
				<div class="container">
					<div>
						<span>10</span>
						<span>
							<span class="fa fa-bank"></span>
						</span>
						<p>银行</p>
					</div>
					<div>
						<span>20</span>
						<span>
							<span class="fa fa-money"></span>
						</span>
						<p>私募股权/投资基金</p>
					</div>
					<div>
						<span>15</span>
						<span>
							<span class="fa fa-building"></span>
						</span>
						<p>房地产</p>
					</div>
					<div>
						<span>19</span>
						<span>
							<span class="fa fa-lightbulb-o"></span>
						</span>
						<p>能源与自然资源</p>
					</div>
					<div>
						<span>13</span>
						<span>
							<span class="fa fa-chain"></span>
						</span>
						<p>信息技术、电信、传媒与娱乐</p>
					</div>
					<div>
						<span>15</span>
						<span>
							<span class="fa fa-gears"></span>
						</span>
						<p>制造业</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				page: 1,
				pageCount: 3,
				mouseWheelLimit: 100,
				mouseWheelCount: 0,
				mouseWheelDirection: true, //true-向上滑动、false-向下滑动
				mouseWheelTimeDuration: 1200, //每一次滚动后需要间隔x秒才能滚动下一页
				mouseWheelDisabled: false,
			}
		},
		watch: {
			page(value) {
				document.body.setAttribute('aboutpage', value);
			},
			mouseWheelCount(value) {
				if (value >= this.mouseWheelLimit) {
					this.mouseWheelCount = 0;
					if (this.mouseWheelDirection && (this.page < this.pageCount)) {
						this.page++;
					} else if (!this.mouseWheelDirection && (this.page > 1)) {
						this.page--;
					}
					this.mouseWheelDisabled = true;
					this.mouseWheelTimer();
				}
			}
		},
		mounted() {
			const $this = this;
			setTimeout(function () {
				$this.page = 1;
				document.body.setAttribute('aboutpage', $this.page);
			}, 100);

			var browser = this.$util.browser();
			if (['chrome', 'ie', 'opera'].indexOf(browser) != -1) {
				this.mouseWheelLimit = 10;
				window.onmousewheel = document.onmousewheel = this.mouseWheel;
			} else if (['firefox'].indexOf(browser) != -1) {
				this.mouseWheelLimit = 5;
				document.addEventListener('DOMMouseScroll', this.mouseWheel, false);
			}
		},
		beforeRouteLeave(to, from, next) {
			document.body.removeAttribute('aboutpage');
			next();
		},
		methods: {
			mouseWheel(e) {
				if (this.mouseWheelDisabled) {
					return;
				}
				//console.log(e.wheelDelta, e.detail)
				this.mouseWheelCount++;
				if (e.wheelDelta < 0) {
					this.mouseWheelDirection = true;
				} else if (e.wheelDelta > 0) {
					this.mouseWheelDirection = false;
				} else if (e.detail > 0) {
					this.mouseWheelDirection = true;
				} else if (e.detail < 0) {
					this.mouseWheelDirection = false;
				}
				//console.log(this.mouseWheelCount, this.mouseWheelDirection)
			},
			mouseWheelTimer() {
				const $this = this;
				setTimeout(function () {
					$this.mouseWheelDisabled = false;
				}, this.mouseWheelTimeDuration);
			}
		}
	}
</script>
